<template>
  <div class="banner">
    <div class="banner-content" :style="currentSlideStyle">
      <div class="banner-box">
        <div class="left-content">
          <div class="title-one" v-html="$t(currentSlide.title)"></div>
          <div class="title-two" v-html="$t(currentSlide.subtitle)"></div>
          <button class="banner-button" @click="goToPage(currentSlide.buttonLink)">
          {{ $t("slidebuttonText") }}
          </button>
        </div>
      </div>
    </div>
    <div class="dots">
      <span
        v-for="(slide, index) in slides"
        :key="index"
        @click="goToSlide(index)"
        :class="{ active: currentSlideIndex === index }"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slides: [
        {
          background: require("../assets/img/vidio3.gif"),
          title: "slidetitle",
          subtitle: "slidesubtitle",
          buttonLink: "ProductPage1",
        }
        // 添加更多的幻灯片
      ],
      currentSlideIndex: 0,
      intervalId: null,
    };
  },
  computed: {
    currentSlide() {
      return this.slides[this.currentSlideIndex];
    },
    currentSlideStyle() {
      return {
        "background-image": `url(${this.currentSlide.background})`,
      };
    },
  },
  methods: {
    goToSlide(index) {
      this.currentSlideIndex = index;
    },
    goToPage(pageName) {
      if (this.$route.name !== pageName) {
        this.$router.push({ name: pageName });
      }
    },
  },
};
</script>

<style scoped>
.banner {
  float: left;
  width: 100%;
  height: 800px;

  position: relative;
  overflow: hidden;
}

.banner-content {
  height: 800px;
  color: white;
  text-align: left;
  background-size: 100%;
}
.banner-box {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100%; /* 确保容器有高度 */
}

.left-content {
  max-width: 100%;
  display: flex; /* 使内容在内部容器中也居中 */
  flex-direction: column; /* 内容纵向排列 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  padding: 0 20px;
  box-sizing: border-box;
}
.title-one {
  font-size: 40px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 800;
}
.title-two {
  font-size: 24px;
  color: #fff;
  margin-bottom: 30px;
  /* letter-spacing: 15px; */
}

/* .right-content {
  max-width: 20%;
  text-align: right;
} */

.banner-button {
  background-color: #ca391b;
  color: white;
  border: none;
  padding: 15px 50px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 5px;
}

.dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}

.dots span {
  width: 12px;
  height: 12px;
  margin: 0 6px;
  background-color: grey;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
}

.dots span.active {
  background-color: red;
}

@media (max-width: 1200px) {
  .banner {
    height: 250px;
  }
  .banner-content {
    height: 250px;
  }
  .banner-box {
    width: 100%;
  }

  .title-one {
    font-size: 20px;
  }
  .title-two {
    font-size: 12px;
  }
  .banner-button {
    zoom: 0.8;
  }
}
</style>